import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { SubmitConfig } from '../_configs/submit.config'
import { ClipLoader } from 'react-spinners'

// Components
import { Breadcrumbs } from '../_components/Breadcrumbs'
import { Invoices } from '../_components/Invoices'
import ImgLink from '../_components/ImgLink'
import { dealService } from '../_services'
import { dealActions } from '../_actions'
import { OriginateFormHeader } from '../_components/OriginateFormHeader'

// Constants
import { tenantColors } from '../_constants/colors'
import ROUTES from '../_constants/routes'

// Helpers
import { history } from '../_helpers'
import { COMPANY_NAME } from 'xen/constants'

// Styled Componenets
const Submitted = styled.div`
  .main-content {
    width: 80%;
    margin: 0 auto;
    padding: 25px 0px;
    max-width: 1000px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;

    .date {
      margin-top: 1em;
    }
    .finalizing-rate {
      display: flex;
      flex-direction: column;
      justify-items: center;
      justify-content: center;
      align-items: center;

      .finalizing-rate-img {
        padding-top: 8px;
        max-width: 100%;
        @media screen and (min-width: 700px) {
          height: 25vh;
        }
      }
      .submitted-img {
        padding-top: 8px;
        max-width: 100%;
        @media screen and (min-width: 700px) {
          height: 25vh;
        }
      }

      .text {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-left: 32px;
        margin-right: 32px;
        @media screen and (min-width: 700px) {
          text-align: left;
        }

        p {
          line-height: 1.5em;
          opacity: 0.75;
          margin-top: 24px;
          font-size: 20px;
        }
      }
    }
    .submit-images {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 32px;
      margin-bottom: 10vh;
    }
  }
`

class SubmittedPage extends React.Component {
  state = {
    submittedDealInvoices: [],
  }
  componentDidMount = () => {
    const { business, setDeal } = this.props

    if (!business.completed_profile) {
      history.push(ROUTES.confirm_form)
    } else {
      dealService.getDealsToDate(business.id).then((resp) => {
        for (let i in resp.deals) {
          const deal = resp.deals[i]
          const dealInvoiceDocuments = resp.invoice_documents[i]
          const dealInvoices = resp.invoices[i]
          const dealDebtors = resp.debtors[i]
          const dealDocuments = resp.deal_documents[i]
          const dealSupportingDocuments = resp.deal_supporting_documents[i]

          if (i == 0) {
            this.setState({
              submittedDealInvoices: dealInvoices,
            })
            setDeal(deal)
          }
          if (deal.deal_status !== `submitted`) {
            continue
          }

          deal.debtorNames = []
          deal.faceValues = []
          deal.isPreapproved = []
          deal.totalFaceValue = 0
          deal.totalPreAppCustomers = 0
          deal.customers = []

          dealInvoices.map((dealInvoice, j) => {
            if (dealDebtors[j] !== undefined) {
              dealInvoice.debtor_name = dealDebtors[j].debtor_name
            }
            deal.debtorNames.push(dealInvoice.debtor_name)
            deal.faceValues.push(dealInvoice.face_value)
            deal.isPreapproved.push(dealInvoice.preapproved)

            deal.totalFaceValue += parseFloat(dealInvoice.face_value)
          })

          deal.totalNumInvoices = dealInvoices.length

          const uniqDebtorNames = [...new Set(deal.debtorNames)]

          uniqDebtorNames.forEach((uniqName) => {
            let numCustomerInvoices = 0
            let totalCustomerFaceValue = 0
            let preapprovedCustomer = false

            deal.debtorNames.map((name, k) => {
              if (name === uniqName) {
                numCustomerInvoices += 1
                totalCustomerFaceValue += deal.faceValues[k]
                preapprovedCustomer = preapprovedCustomer || deal.isPreapproved[k]
              }
            })

            const currentCustomer = {
              name: uniqName,
              numInvoices: numCustomerInvoices,
              faceValue: totalCustomerFaceValue,
              preapproved: preapprovedCustomer,
            }

            deal.totalPreAppCustomers += preapprovedCustomer
            deal.customers.push(currentCustomer)
          })

          if (this.state.submittedDeals) {
            this.setState((prevState) => ({
              submittedDeals: prevState.submittedDeals ? [...prevState.submittedDeals, deal] : [deal],
            }))
          } else {
            this.setState({
              submittedDeals: [deal],
            })
          }
        }
        this.setState((prevState) => {
          if (prevState.submittedDeals) {
            return {
              submittedDeals: this.sortObjectArray(prevState.submittedDeals, `created_at`, `des`, true),
            }
          } else {
            return {
              submittedDeals: [],
            }
          }
        })
      })
    }
  }

  sortObjectArray = (arrayOfObjects, sortParam, order, isDate) => {
    let outputArray = arrayOfObjects.slice(0)
    if (isDate) {
      for (var i in outputArray) {
        outputArray[i][sortParam] = new Date(outputArray[i][sortParam])
      }
    }
    outputArray.sort(function (a, b) {
      switch (order.substr(0, 3)) {
        case 'asc':
          return isDate ? new Date(a[sortParam]) - new Date(b[sortParam]) : a[sortParam] - b[sortParam]
        case 'des':
          return isDate ? new Date(b[sortParam]) - new Date(a[sortParam]) : b[sortParam] - a[sortParam]
        default:
          return isDate ? new Date(a[sortParam]) - new Date(b[sortParam]) : a[sortParam] - b[sortParam]
      }
    })
    return outputArray
  }

  render() {
    const { tenant, user, business } = this.props
    const { submittedDeals } = this.state
    return (
      <Submitted>
        <Helmet>
          <title>Submitted • {COMPANY_NAME}</title>
        </Helmet>
        {!business.is_client ? <Breadcrumbs activeItem={`Submitted`} /> : ''}
        <div className={`main-content`}>
          <OriginateFormHeader
            subtitle={business.business_name || user.email_address}
            title={SubmitConfig[tenant].title}
          />
          {!submittedDeals ? (
            <ClipLoader color={tenantColors[tenant].secondary} loading={true} size={100} />
          ) : (
            submittedDeals.map((deal) => deal.customers.length > 0 && <Invoices data={deal} key={deal.id} />)
          )}
          <div className={`finalizing-rate`}>
            <div className={`text`}>
              <p dangerouslySetInnerHTML={{ __html: SubmitConfig[tenant].body.replace(/\n/g, '<br />') }} />
            </div>
            <div className={`submit-images`}>
              {SubmitConfig[tenant].finalizingRateImg ? (
                <ImgLink
                  className={`finalizing-rate-img`}
                  cssSetsHeight={true}
                  src={SubmitConfig[tenant].finalizingRateImg}
                />
              ) : null}
              <ImgLink
                className={`submitted-img`}
                cssSetsHeight={true}
                href={SubmitConfig[tenant].submittedHref}
                src={SubmitConfig[tenant].submittedImg}
                target={'_blank'}
              />
            </div>
          </div>
        </div>
      </Submitted>
    )
  }
}

function mapStateToProps(state) {
  const { env, user, business, deal } = state
  return {
    tenant: env.tenant,
    user,
    business,
    submittedDeals: deal.submittedDeals,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setDeal: (deal) => {
      dispatch(dealActions.setDeal(deal))
    },
  }
}

const connectedSubmittedPage = connect(mapStateToProps, mapDispatchToProps)(SubmittedPage)
export { connectedSubmittedPage as SubmittedPage }
